import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { iconCodes } from '../../../../libs/open-weather-map/open-weather-map-to-weather-icons';
import { WeatherEntity } from '../../../dave-data-module/entities/weather.entity';
import { getFetched$ } from '../../../dave-data-module/helper/helper';
import { State } from '../../../dave-data-module/State';
import { getPartnerMainOffice, getPartnerOfficesFetched } from '../../../dave-data-module/State/selectors/partners.selectors';
import { WeatherHttpService } from '../../../services/weather-http.service';
import { getCurrencyCode } from '../../../helper/country-codes';

@Component({
    selector: 'app-weather',
    templateUrl: './weather.component.html',
    styleUrls: ['./weather.component.scss'],
})
export class WeatherComponent implements OnInit, OnDestroy {
    @Input() Clock = true;

    private interval: number;

    public CurrentWeather$: Observable<WeatherEntity>;
    public Now: string;

    constructor(private weatherHttpService: WeatherHttpService, store: Store<State>) {
        this.CurrentWeather$ = getFetched$(store, getPartnerOfficesFetched, getPartnerMainOffice).pipe(
            // map((partnerOffice) => partnerOffice.City),
            distinctUntilChanged((a,b) => a.City === b.City && a.Country === b.Country),
            switchMap((partnerOffice) => (partnerOffice.City ? this.weatherHttpService.getWeather(partnerOffice.City, getCurrencyCode(partnerOffice.Country) || 'de').pipe(map((res) => (res ? new WeatherEntity(res.weather[0].description, this.getWeatherImageUrl(res.weather[0].id), partnerOffice.City, res.main.temp) : null))) : of(null))),
        );
    }

    ngOnInit() {
        this.interval = window.setInterval(() => {
            const time = new Date();
            this.Now = ('0' + time.getHours()).substr(-2) + ('0' + time.getMinutes()).substr(-2) + ('0' + time.getSeconds()).substr(-2);
        }, 1000);
    }

    ngOnDestroy(): void {
        clearInterval(this.interval);
    }

    private getWeatherImageUrl(weatherId: number) {
        const prefix = 'wi wi-';
        const code = weatherId;
        let icon = iconCodes[code].icon;

        // If we are not in the ranges mentioned above, add a day/night prefix.
        if (!(code > 699 && code < 800) && !(code > 899 && code < 1000)) {
            icon = 'day-' + icon;
        }
        // Finally tack on the prefix.
        return prefix + icon;
    }

    public Round(num: number) {
        return (Math.ceil(num * 2) / 2).toFixed(1);
    }
}
